import React, { useState, useEffect, useMemo, useRef } from 'react'
import { ContentHeader, Loader } from '@components';
import { TableHeader, Pagination, Search } from '@app/components/react-data-table';
import moment from 'moment';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { getPortals, getPortalById } from '../../services/portal';
import AddPortals from './AddPortals';
import { toast } from 'react-toastify';

const Poartals = () => {
    const componentRef = useRef();
    const [listData, setListData] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [isPopLoading, setPopLoading] = useState(false);
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [sorting, setSorting] = useState({ field: "", order: "" });
    const ITEMS_PER_PAGE = 25;
    const [optionData, setOptionData] = useState('');
    const [getId, setId] = useState(0);
    const [fillData, setFillData] = useState({
        uid: '',
        name: ''
    });
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = (id: number) => {
        if (id !== 0) {
            setId(id);
            getPortal(id);
        } else {
            setFillData({
                uid: Math.random().toString(36).slice(2, 20),
                name: '',
            });
            setOptionData('');
            setId(0);
        }

        setShow(true);
    }
    const colomns = [
        { name: "Image", field: "", sortable: false },
        { name: "Name", field: "", sortable: false },
        { name: "Domain", field: "", sortable: false },
        { name: "Created At", field: "", sortable: false },
        { name: "Action", field: "", sortable: false, className: 'td-center d-print-none' }
    ];

    const resultData = useMemo(() => {
        let computedResults = listData;
        if (search) {
            computedResults = computedResults.filter(
                data => data.name.toLowerCase().includes(search.toLowerCase())
            );
        }
        setTotalItems(computedResults.length);
        //Sorting listData
        if (sorting.field) {
            const reversed = sorting.order === "asc" ? 1 : -1;
            computedResults = computedResults.sort(
                (a, b) =>
                    reversed * a[sorting.field].localeCompare(b[sorting.field])
            );
        }
        //Current Page slice
        return computedResults.slice(
            (currentPage - 1) * ITEMS_PER_PAGE,
            (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
        );
    }, [listData, currentPage, search, sorting]);


    useEffect(() => {
        setSearch("");
        getList();
    }, [])

    const getPortal = (id: any) => {
        setPopLoading(true);
        getPortalById(id).then(function (res: any) {
            const resp = res.data;
            setPopLoading(false);
            if (res.status === 200 && resp.Acknowledge == 1) {
                let respData = resp.record;
                setFillData({
                    uid: Math.random().toString(36).slice(2, 20),
                    name: respData.name,
                });
                setOptionData(respData.SUPPLIER_PARTY_ID);
            }
        }).catch(err => {
            setPopLoading(false);
            toast.error(err.response.data.FullMessage !== 'undefied' ? err.response.data.FullMessage : 'Internal Server Error!');
        });
    };

    const getList = (filter = "") => {
        setLoading(true);
        getPortals(filter).then(function (res) {
            const resp = res.data;
            if (resp.Acknowledge == 1 && resp.records) {
                let data: any = [];
                resp.records.map((val: any, i: any) => {
                    data[i] = {
                        id: val.id,
                        name: val.name,
                        image: val.image,
                        dev_url: val.dev_url,
                        prod_url: val.prod_url,
                        created_at: val.created_at ? moment(val.created_at).format('MM/DD/YYYY') : '',
                        updated_at: val.updated_at ? moment(val.updated_at).format('MM/DD/YYYY') : ''
                    };
                });
                setListData(data);
                setLoading(false);
            }
        }).catch(err => {
            setLoading(false);
            return false;
        });
    };

    return (
        <>
            <ContentHeader title="Portals" />
            <section className="content">
                <div className="container-fluid">
                    <div className="col-12">
                        <div className="card order_listing future_delivery_listing">
                            <div className="card-body">
                                <div className='table-warp-search-pagination'>
                                    <div className='d-flex custom-pagination justify-content-between'>
                                        <Search
                                            onSearch={value => {
                                                setSearch(value);
                                                setCurrentPage(1);
                                            }}
                                        />
                                    </div>
                                    <div className='listing_table_wrap med_table_wrap' ref={componentRef}>
                                        <h3 className='d-none d-print-block m-2'>Portals</h3>
                                        <table className="cell-border table table-bordered table-striped" style={{ width: '100%' }} >
                                            <TableHeader
                                                headers={colomns}
                                                onSorting={(field, order) =>
                                                    setSorting({ field, order })
                                                }
                                            />
                                            <tbody>
                                                {resultData.length > 0 ? resultData.map((row: any, podidx: number) => (
                                                    <tr key={podidx}>
                                                        <td className='td-left'><img src={`/img/portals/${row.image}`} alt={row.name} width={75} /></td>
                                                        <td className='td-left'>{row.name}</td>
                                                        <td className='td-left'>Dev URL : <a href={row.dev_url} target='_blank'>{row.dev_url}</a> <br /> PROD URL : <a href={row.prod_url} target='_blank'>{row.prod_url}</a> </td>
                                                        <td className='td-left'>{row.created_at}</td>
                                                        <td style={{ width: '10%', textAlign: 'center' }} className='d-print-none'>
                                                            <a className="btn edit_btn p-0 pr-2" onClick={() => handleShow(row.id)} title="Edit"><i className="nav-icon far fa-edit"></i></a>
                                                        </td>
                                                    </tr>
                                                ))
                                                    : <tr><td style={{ textAlign: 'center' }} colSpan="5">No record found.</td></tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <Pagination
                                        total={totalItems}
                                        itemsPerPage={ITEMS_PER_PAGE}
                                        currentPage={currentPage}
                                        onPageChange={page => setCurrentPage(page)}
                                    />
                                </div>
                            </div>
                            <Loader isLoading={isLoading} />
                        </div>
                    </div>
                </div>
            </section >
            <AddPortals isPopLoading={isPopLoading} getId={getId} setOptionData={setOptionData} optionData={optionData} fillData={fillData} setFillData={setFillData} show={show} loadList={getList} setShow={setShow} handleClose={handleClose} />
        </>
    );
};

export default Poartals;
